import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors";

const urlContrating = "Contrating"
export const getContratacionReferencia = async ({ Referencia }) => {
    return axios.get(`${APIURL}/${urlContrating}/Reference/${Referencia}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const getContratacionPlazaReferencia = async ({ Referencia }) => {
    return axios.get(`${APIURL}/${urlContrating}/TipoPlaza/${Referencia}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            //return Error.response.data;
            return [];
        })
}
export const putContratacionPlaza = async ({ IdContratacion, suplementosEnviados }) => {
    return axios.put(`${APIURL}/${urlContrating}/TipoPlaza`, {
            IdContratacion,
            suplementosEnviados
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
